import googlePayment from 'braintree-web/google-payment';
import { ActionStatus } from '../../../../common/constants/action-status';
import { StoreState } from '../../../../store/store.interface';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createClient, getBraintreeClient } from '../../braintree';
import { isProdEnv } from '../../../../common/environment';
import store, { waitForBraintreeClient } from '../../../../store/store';
import { getClientTokenResponse } from '../../../checkout/shop-checkout';

/**
 * Create braintree Google Pay instance only once.
 */
export const createGooglePayInstance = createAsyncThunk(
  'braintree/createGooglePayInstance',
  async (_data: any, thunkAPI) => {
    try {
      await thunkAPI.dispatch(createClient(_data));
      await waitForBraintreeClient();
      
      const tokenResponse = getClientTokenResponse(store.getState() as StoreState);
      const configuration: any = {
        client: getBraintreeClient(thunkAPI.getState() as StoreState),
        googlePayVersion: 2,
      };

      console.log(`Merchant Id ${tokenResponse!.googleMerchantId}`);
      if (isProdEnv()) {
        console.log(`Google Pay is in prod, configuring the merchant id`);
        configuration.googleMerchantId = tokenResponse!.googleMerchantId;
      }
      return await googlePayment.create(configuration);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: (_arg, { getState }) => {
      const state = getState() as StoreState;
      if (
        state.braintreeState.googlePayInstance.status === ActionStatus.loading ||
        state.braintreeState.googlePayInstance.status === ActionStatus.succeeded
      ) {
        return false;
      }
      return true;
    },
  }
);
